import { type FC } from "react";
import ExitFullscreenIcon from "./icons/ExitFullscreenIcon";
import EnterFullscreenIcon from "./icons/EnterFullscreenIcon";

interface FullscreenToggleButtonProps {
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
}

const FullscreenToggleButton: FC<FullscreenToggleButtonProps> = ({ isFullscreen, onToggleFullscreen }) => {
  return (
    <button
      type="button"
      onClick={onToggleFullscreen}
      className="hidden cursor-pointer text-lastbot-icon-muted md:block"
      data-testid={`fullscreen-toggle`}
    >
      {isFullscreen ? <ExitFullscreenIcon /> : <EnterFullscreenIcon />}
    </button>
  );
};

export default FullscreenToggleButton;
